/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestmentEntityDetail} from '../api'

 export const useQueryGetInvestmentEntityDetail = createReactQueryHook('getInvestmentEntityDetail', getInvestmentEntityDetail)
